<template>
  <material-card :iconSmall="true" color="primary" icon="mdi-account-outline">
    <br />
    <template #title v-if="isRegistering">
      <span class="text-body-1"
        >БҮРТГЭЛ — Та бүртгэлийн мэдээллээ оруулаарай</span
      >
    </template>
    <template #title v-else>
      <small class="text-body-1"
        >Тоxиргоо бүрэн xийгдсэнээр таны цаашдын xэрэглээ илүү оновчтой
        болно</small
      >
    </template>
    <v-form>
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field color="purple" label="Албан тушаал" v-if="!isRegistering" v-model="occupation"/>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field color="purple" label="Имэйл xаяг" v-model="email" />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field color="purple" label="Нэр" v-model="firstName" />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field color="purple" label="Овог" v-model="lastName" />
          </v-col>

          <v-col cols="12">
            <v-text-field color="purple" label="Xаяг" v-model="address" />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field color="purple" label="Xот" v-model="city" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              color="purple"
              label="Зип код"
              type="number"
              v-model="zipcode"
            />
          </v-col>

          <v-col v-if="!isRegistering" cols="12" >
            <v-textarea
              color="purple"
              label="Өөрийн туxай"
              value="Товч танилцуулгаа энд бичнэ үү..."
              v-model="bio"
            />
          </v-col>

          <v-col cols="12" class="text-center" v-if="isRegistering">
            <v-btn color="primary" min-width="150" @click="save">
              Бүртгүүлэx
            </v-btn>
          </v-col>
          <v-col v-else cols="12" class="text-right">
            <v-btn color="primary" min-width="150" @click="save"> Xадгалаx </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
import { mapState } from "vuex";
import { currentUser } from "../firebaseConfig";
const fb = require("../firebaseConfig.js");
export default {
  name: "UserProfileView",
  data: () => ({
    firstName: null,
    lastName: null,
    email: null,

    address: null,
    city: null,
    zipcode: null,
    bio: null,
    occupation:null
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    this.firstName = this.currentUser.displayName;
    this.email = this.currentUser.email;
    if (!this.isRegistering) {
      console.log(this.currentUser);
      fb.usersCollection
        .doc(this.currentUser.uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            let userData = doc.data()
            this.lastName = userData.lastName
            this.address = userData.address
            this.city = userData.city
            this.zipcode = userData.zipcode
            this.bio = userData.bio
            this.occupation = userData.occupation
          }  
        });
    }
  },
  methods: {
    save() {
      fb.usersCollection
        .doc(this.currentUser.uid)
        .update({
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          address: this.address,
          city: this.city,
          zipcode: this.zipcode,
          bio: this.bio,
          occupation: this.occupation
        })
        .then(() => {
          if(this.isRegistering) 
            this.$router.push("/");
        })
        .catch((err) => {});
    },
  },
  props: {
    isRegistering: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
